export default {
  namespaced: true,
  state: {
    isLoading: false
  },
  getters: {
    loading: state => {
      return state.isLoading
    }
  },
  mutations: {
    setLoading(state, boolean) {
      state.isLoading = boolean
    }
  },
  actions: {
    setLoading(state, boolean) {
      state.commit("setLoading", boolean)
    }
  }
}
